import IconType from './iconType';

export default function InstagramIcon({
  width = 16,
  height = 16,
  color = '#667085',
}: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2335 0H4.76649C2.13823 0 0 2.13823 0 4.76649V11.2335C0 13.8618 2.13823 16 4.76649 16H11.2335C13.8618 16 16 13.8618 16 11.2335V4.76649C16 2.13823 13.8617 0 11.2335 0ZM14.3904 11.2335C14.3904 12.977 12.977 14.3904 11.2335 14.3904H4.76649C3.023 14.3904 1.6096 12.977 1.6096 11.2335V4.76649C1.6096 3.02297 3.023 1.6096 4.76649 1.6096H11.2335C12.977 1.6096 14.3904 3.02297 14.3904 4.76649V11.2335Z"
        fill={color}
      />
      <path
        d="M8.00145 3.8623C5.71966 3.8623 3.86328 5.71868 3.86328 8.00044C3.86328 10.2822 5.71966 12.1386 8.00145 12.1386C10.2832 12.1386 12.1396 10.2822 12.1396 8.00044C12.1396 5.71865 10.2832 3.8623 8.00145 3.8623ZM8.00145 10.529C6.60495 10.529 5.47288 9.39698 5.47288 8.00047C5.47288 6.60397 6.60498 5.4719 8.00145 5.4719C9.39795 5.4719 10.53 6.60397 10.53 8.00047C10.53 9.39695 9.39792 10.529 8.00145 10.529Z"
        fill={color}
      />
      <path
        d="M12.1478 4.88449C12.6954 4.88449 13.1394 4.44055 13.1394 3.89293C13.1394 3.3453 12.6954 2.90137 12.1478 2.90137C11.6002 2.90137 11.1562 3.3453 11.1562 3.89293C11.1562 4.44055 11.6002 4.88449 12.1478 4.88449Z"
        fill={color}
      />
    </svg>
  );
}
